import { shareButton, shareButtonGroup } from '../../shared/index.css'

export const getShareButtons = () => {
  return `
  <div class="${shareButtonGroup}">
    <a class="nrk-button nrk-button--o ${shareButton}" data-share="Article:Facebook" rel="noopener" target="_blank" href="https://www.facebook.com/sharer.php?u=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870">
      <span class="nrk-sr">Del på Facebook</span>
      <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-some-facebook" /></svg>
    </a>
    <a class="nrk-button nrk-button--o ${shareButton}" data-share="Article:Twitter" rel="noopener" target="_blank" href="https://twitter.com/intent/tweet?url=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870;text=Min reise i krigens Syria">
      <span class="nrk-sr">Del på Twitter</span>
      <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-some-twitter" /></svg>
    </a>
  </div>
  `

}



// WEBPACK FOOTER //
// ./src/client/utils/getShareButtons.js